/**
 * =====================================================
 * TBC Product Grid
 * AJAX Quick Add
 * =====================================================
 */

class TBCProductGrid {

  constructor() {
    this.init();
  }

  init() {
    document.addEventListener('submit', this.onSubmit.bind(this));
  }

  async onSubmit(event) {

    const form = event.target.closest('[data-product-form]');

    if (!form) return;

    event.preventDefault();

    const button = form.querySelector('button');

    if (!button) return;

    this.setLoading(button, true);

    const formData = new FormData(form);

    try {

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json'
        },
        body: formData
      });

      if (!response.ok) {
        throw new Error('Unable to add product.');
      }

      await response.json();

      await this.refreshCart();

      this.showSuccess(button);

    } catch (error) {

      console.error(error);

      this.showError(button);

    } finally {

      setTimeout(() => {
        this.resetButton(button);
      }, 1500);

    }

  }

  async refreshCart() {

    const response = await fetch('/cart.js');

    const cart = await response.json();

    this.updateCartCount(cart.item_count);

    this.refreshDrawer();

  }

  updateCartCount(count) {

    document.querySelectorAll('[data-cart-count]').forEach((element) => {
      element.textContent = count;
    });

  }

  async refreshDrawer() {

    const drawer =
      document.querySelector('cart-drawer') ||
      document.querySelector('cart-notification');

    if (!drawer) return;

    const response = await fetch('/?section_id=cart-drawer');

    if (!response.ok) return;

    const html = await response.text();

    const parser = new DOMParser();

    const documentHTML = parser.parseFromString(html, 'text/html');

    const newDrawer = documentHTML.querySelector('cart-drawer');

    if (newDrawer && drawer.tagName === 'CART-DRAWER') {

      drawer.innerHTML = newDrawer.innerHTML;

      if (typeof drawer.open === 'function') {
        drawer.open();
      }

      return;
    }

    if (drawer.tagName === 'CART-NOTIFICATION') {

      if (typeof drawer.renderContents === 'function') {
        drawer.renderContents();
      }

    }

  }

  setLoading(button, state) {

    if (state) {

      button.disabled = true;

      button.dataset.original = button.innerHTML;

      button.innerHTML = 'ADDING...';

    }

  }

  showSuccess(button) {

    button.innerHTML = '✓ ADDED';

  }

  showError(button) {

    button.innerHTML = 'ERROR';

  }

  resetButton(button) {

    button.disabled = false;

    button.innerHTML = button.dataset.original;

  }

}

document.addEventListener('DOMContentLoaded', () => {

  new TBCProductGrid();

});